import React from 'react';
import AdminSignupsContainer from '../components/adminSignups.container';

/** `/admin/signups` — the operational queue, defaulting to the failed ones. */
const AdminSignupsPage: React.FC = () => <AdminSignupsContainer />;

export default AdminSignupsPage;
